<template>
  <v-container fluid grid-list-md style="padding: 20px;">
    <v-row>
      <v-col cols="12" sm="12" md="6" v-if="user.tipo == 'ADMIN'">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaPaineis(empresaSelecionada)"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <v-data-table
          :search="tabela.busca"
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          sort-by="titulo"
          class="elevation-1"
          style="border-radius: 10px;"
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
          :loading="tabela.carregamento"
          loading-text="Buscando itens..."
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">PAINÉIS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field v-model="tabela.busca" append-icon="search" label="Procurar" single-line hide-details></v-text-field>
              <v-spacer v-if="user.tipo == 'ADMIN'"></v-spacer>
              <v-btn text @click="dialogoPainel = true" tile color="#3BA8A2" v-if="user.tipo == 'ADMIN'">
                <v-icon left dark>add_circle</v-icon>Cadastrar
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="editItem(item)" color="#01579B">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom v-if="user.tipo == 'ADMIN'">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="deleteItem(item)" color="#FF0000">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.ativo`]="{ item }">
            <v-icon :color="item.ativo == true ? 'success' : 'error'">mdi-circle</v-icon>
          </template>
          <template v-slot:[`item.sala`]="{ item }">
            <td>{{ exibeListaSalas(item.sala) }}</td>
          </template>
          <template v-slot:no-data>
            <v-row style="margin: 0px">
              <v-col>
                <v-alert v-if="user.tipo == 'ADMIN' && empresaSelecionada == ''" dark dense text outlined color="info" icon="info" style="margin: 0px">Selecione uma empresa para visualizar os painéis</v-alert>
                <v-alert v-if="empresaSelecionada" dark dense text outlined color="warning" icon="info" style="margin: 0px">Nenhum painel cadastrado</v-alert>
                <v-alert v-if="user.tipo != 'ADMIN'" dark dense text outlined color="warning" icon="info" style="margin: 0px">Nenhum painel cadastrado</v-alert>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogoPainel" persistent max-width="500px" scrollable>
      <v-card>
        <v-card-title>{{ formTitle }}</v-card-title>
        <v-card-text style="padding-bottom: 10px; padding-top: 10px">
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field
                label="Nome*"
                outlined
                dense
                hide-details
                v-model="editedItem.descricao"
                :disabled="user.tipo != 'ADMIN'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-text-field
                label="Endereço MAC*"
                outlined
                dense
                hide-details
                v-model="editedItem.mac"
                v-mask="'XX:XX:XX:XX:XX:XX'"
                :disabled="user.tipo != 'ADMIN'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-switch
                v-model="editedItem.ativo"
                :label="editedItem.ativo ? 'Ativo' : 'Inativo'"
                inset
                hide-details
                style="padding: 0px; margin-top: 8px"
                :disabled="user.tipo != 'ADMIN'"
              ></v-switch>
            </v-col>

            <v-col cols="12">
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Salas
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row dense>
                      <v-col cols="9">
                        <v-text-field dense v-model="textoSala" counter="100" maxlength="100" outlined label="Sala"></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-btn block color="success" @click="adicionaOpcoesEscolhaSala">
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col cols="12">
                        <div v-if="editedItem.sala.length == 0">
                          <v-alert style="margin: 0px" dark dense text outlined :value="true" color="warning" icon="info">Nenhuma sala informada</v-alert>
                        </div>
                        <div v-else :key="x" style="border: 1px #bbb solid; padding: 10px; border-radius: 5px">
                          <v-list dense v-for="(item, index) in editedItem.sala" :key="item" style="padding: 0px">
                            <v-list-item style="padding: 0px">
                              <v-list-item-content style="padding: 0px">
                                <v-list-item-title>{{ item }}</v-list-item-title>
                              </v-list-item-content>
          
                              <v-list-item-action>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                      <v-icon @click="editarOpcao(item, 'SALA')" color="blue">mdi-pencil</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Editar</span>
                                </v-tooltip>
          
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                      <v-icon @click="removerOpcao(item, 'SALA')" color="red">mdi-delete</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Excluir</span>
                                </v-tooltip>
                              </v-list-item-action>
                            </v-list-item>
          
                            <v-divider v-if="index < editedItem.sala.length - 1" :key="index"></v-divider>
                          </v-list>
                        </div>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Portarias
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row dense>
                      <v-col cols="9">
                        <v-text-field dense v-model="textoPortaria" counter="100" maxlength="100" outlined label="Portaria"></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-btn block color="success" @click="adicionaOpcoesEscolhaPortaria">
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col cols="12">
                        <div v-if="editedItem.portarias.length == 0">
                          <v-alert style="margin: 0px" dark dense text outlined :value="true" color="warning" icon="info">Nenhuma portaria informada</v-alert>
                        </div>
                        <div v-else :key="x" style="border: 1px #bbb solid; padding: 10px; border-radius: 5px">
                          <v-list dense v-for="(item, index) in editedItem.portarias" :key="item" style="padding: 0px">
                            <v-list-item style="padding: 0px">
                              <v-list-item-content style="padding: 0px">
                                <v-list-item-title>{{ item }}</v-list-item-title>
                              </v-list-item-content>
          
                              <v-list-item-action>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                      <v-icon @click="editarOpcao(item, 'PORTARIA')" color="blue">mdi-pencil</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Editar</span>
                                </v-tooltip>
          
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                      <v-icon @click="removerOpcao(item, 'PORTARIA')" color="red">mdi-delete</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Excluir</span>
                                </v-tooltip>
                              </v-list-item-action>
                            </v-list-item>
          
                            <v-divider v-if="index < editedItem.portarias.length - 1" :key="index"></v-divider>
                          </v-list>
                        </div>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialogoPainel = false">Fechar</v-btn>
          <v-btn text color="success" @click="salvarUsuario" v-if="editedIndex == -1">Salvar</v-btn>
          <v-btn text color="success" @click="editarUsuario" v-if="editedIndex != -1">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#3BA8A2" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      isLoading: false,
      fullPage: true,
      empresas: [],
      empresaSelecionada: '',
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'descricao', },
          { text: 'Endereço MAC', value: 'mac' },
          { text: 'Sala', value: 'sala', width: '700px' },
          { text: 'Portarias', value: 'portarias' },
          { text: 'Ativo', value: 'ativo' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        carregamento: false,
        conteudo: [],
      },
      sexos: [
        { text: 'Masculino', value: 'MASCULINO' },
        { text: 'Feminino', value: 'FEMININO' },
      ],
      dialogoPainel: false,
      editedIndex: -1,
      editedItem: {
        descricao: '',
        ativo: true,
        mac: '',
        sala: [],
        portarias: [],
        empresaId: '',
      },
      defaultItem: {
        descricao: '',
        ativo: true,
        mac: '',
        sala: [],
        portarias: [],
        empresaId: '',
      },
      professores: [],
      textoSala: '',
      textoPortaria: '',
      x: 0,
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'Adicionar novo painel' : 'Editar painel'
      },
    }),

    watch: {
      dialogoPainel(val) {
        if (val == false) {
          setTimeout(() => {
            this.editedIndex = -1
            this.editedItem = Object.assign({}, this.defaultItem)
          }, 300);
        }
      },

      empresas() {
        this.empresaSelecionada = this.empresas[0].id
        this.carregaPaineis(this.empresaSelecionada)
      },
    },

    mounted() {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaPaineis(this.companyobj.id)
      }
      
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaPaineis(id) {
        this.tabela.conteudo = []
        this.tabela.carregamento = true
        await axios.get(baseApiUrl + 'Paineis?filter={"where":{"empresaId":"' + id + '"}, "order": "descricao ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.tabela.conteudo = response.data
            this.tabela.carregamento = false
          }
        })
      },

      editItem(item) {
        this.isLoading = true
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)

        if (!item.portarias) {
          this.editedItem.portarias = []
        }

        this.dialogoPainel = true
        this.isLoading = false
      },

      async salvarUsuario() {
        var vm = this;
        if (!this.editedItem.descricao || !this.editedItem.mac || !this.editedItem.ativo || this.editedItem.sala.length == 0) {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha todos os campos para prosseguir", "ATENÇÃO")
        } else {
          this.isLoading = true
          this.editedItem.empresaId = this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id
          await axios.post(baseApiUrl + 'Paineis?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              if (response.data) {
                this.dialogoPainel = false
                vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
                this.carregaPaineis(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
              }
            }
          })
          .catch(() => {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#FF0000", "Problema ao realizar operação, tente novamente", "DESCULPE")
          })
          this.isLoading = false
        }
      },

      async editarUsuario() {
        var vm = this;
        if (!this.editedItem.descricao || !this.editedItem.mac  || !this.editedItem.ativo || this.editedItem.sala.length == 0) {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha os campos para prosseguir", "ATENÇÃO")
        } else {
          this.isLoading = true
          await axios.put(baseApiUrl + 'Paineis/' + this.editedItem.id + '?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoPainel = false
              vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
              this.carregaPaineis(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
            }           	
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("red", "Erro ao realizar operação", "#BF4554")
          })
        }
      },

      async deleteItem(item) {
        var r = confirm('Realmente deseja EXCLUIR o painel ' + item.descricao + '?')
        if (r == true) {
          await axios.delete(baseApiUrl + 'Paineis/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {    
            var vm = this;
            vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
            this.carregaPaineis(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
          })
        }
      },

      exibeListaSalas(lista) {
        if (lista) {
          let resultado = "";

          lista.forEach((item, index) => {
            if (item.quantidade != "")
              resultado += item;

            if (index !== lista.length - 1 && item.quantidade != "") {
              resultado += ", ";
            }
          });

          return resultado;
        }
      },

      adicionaOpcoesEscolhaSala() {
        var vm = this

        if (!this.textoSala) {
          vm.$refs.chamaSnackbar.snack("#F9A825","Informe uma sala!","ATENÇÃO")
        }
        else {
          this.editedItem.sala.push(this.textoSala)

          setTimeout(() => {
            this.textoSala = ''
          }, 50)
        }
      },

      adicionaOpcoesEscolhaPortaria() {
        var vm = this

        if (!this.textoPortaria) {
          vm.$refs.chamaSnackbar.snack("#F9A825","Informe uma portaria!","ATENÇÃO")
          return
        }
        
        this.editedItem.portarias.push(this.textoPortaria)

        setTimeout(() => {
          this.textoPortaria = ''
        }, 50)
      },

      editarOpcao(item, tipo) {
        if (tipo == 'SALA')
          this.textoSala = item
        else
          this.textoPortaria = item

        this.removerOpcao(item)
      },

      removerOpcao(opcao, tipo) {
        if (tipo == 'SALA') {
          let listaFiltrada = this.editedItem.sala.filter(function(item) {
            return item !== opcao;
          });
  
          this.editedItem.sala = listaFiltrada
        }
        else {
          let listaFiltrada = this.editedItem.portarias.filter(function(item) {
            return item !== opcao;
          });
  
          this.editedItem.portarias = listaFiltrada
        }
        
        this.x++
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #424f4e;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
  
  span.v-stepper__step__step.primary {
    background-color: #009B99!important;
    border-color: #009b9b!important;
  }

  .theme--light.v-stepper .v-stepper__label {
    color: #009B99;
  }

  .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #009B99;
  }
</style>